module.exports = __webpack_public_path__ + "static/media/trust-exercise.b1fe9595.jpg";